import getFilterableContent from './js/fetch';
import { setParams, getParams } from './js/params.js';
import setInputs from './js/inputs';
import { clearFilters } from './js/active-filters.js';
import { slideUp, slideDown } from '../../js/theme/helpers';

/**
 * Initiate filterable content blocks logic.
 */
const initFilterableContent = () => {
	// Get all filterable content blocks.
	const filterableContentBlock = document.querySelectorAll('.em-filterable-content');

	// Loop through each block and apply logic only to that block.
	filterableContentBlock.forEach((block) => {
		const contentContainer = block.querySelector('.em-filterable-content__listings');
		const filterContainer = block.querySelector('.em-filterable-content__filter-container');
		const inputs = block.querySelectorAll('input, select');
		const searchButton = block.querySelector('.search');
		const filterControl = block.querySelector('.em-filterable-content__filter-control');
		const filterInner = block.querySelector('.em-filterable-content__filter-inner');

		// Process filters and search values.
		const getFilteredContent = () => {
			filterContainer.dataset.paged = 1;
			setParams(block);
			const params = getParams(block);
			getFilterableContent(contentContainer, params);
		};

		// Loop through inputs and set event handlers.
		inputs.forEach((input) => {
			if (input.type === 'checkbox' || input.tagName === 'SELECT') {
				input.addEventListener('change', () => {
					getFilteredContent();
				});
			} else {
				input.addEventListener('keyup', (e) => {
					if (e.key === 'Enter') {
						getFilteredContent();
					}
				});
			}
		});

		// If search input not empty submit search.
		searchButton.addEventListener('click', (e) => {
			const button = e.target.closest('button');
			if (button.previousElementSibling.value) {
				getFilteredContent();
			}
		});

		if (filterControl && filterInner) {
			const updateFilterAccordion = () => {
				if (embark.breakpoints.above('sm')) {
					filterInner.style = null;
					filterControl.innerHTML = filterControl.dataset.defaultText;
				} else {
					filterControl.innerHTML = filterControl.dataset.openText;
				}
			};

			const openFilterAccordion = () => {
				filterControl.classList.add('open');
				filterControl.innerHTML = filterControl.dataset.closeText;
				slideDown(filterInner, '.3s', 'flex');
			};

			const closeFilterAccordion = () => {
				filterControl.classList.remove('open');
				filterControl.innerHTML = filterControl.dataset.openText;
				slideUp(filterInner);
			};

			filterControl.addEventListener('click', () => {
				if (embark.breakpoints.below('sm')) {
					if (filterControl.classList.contains('open')) {
						closeFilterAccordion();
					} else {
						openFilterAccordion();
					}
				} else {
					updateFilterAccordion();
				}
			});

			document.addEventListener('click', (e) => {
				if (embark.breakpoints.below('sm')) {
					const { target } = e;
					const closestFilterControl = target.closest('.em-filterable-content__filter-control');
					const closestFilterInner = target.closest('.em-filterable-content__filter-inner');
					if (!closestFilterControl && !closestFilterInner) {
						closeFilterAccordion();
					}
				}
			});

			window.addEventListener('resize', () => {
				window.requestAnimationFrame(() => {
					updateFilterAccordion();
				});
			});

			updateFilterAccordion();
		}

		// Set exisitng values from query string.
		setInputs(block);

		// Get parameters.
		const params = getParams(block);

		// If pagination type is load more reset page to 1 on refresh.
		if (params.pagination === 'load_more') {
			filterContainer.setAttribute('data-paged', 1);
		}

		// Get initial list of posts and output.
		getFilterableContent(contentContainer, params);

		// Initiate clear filters button..
		clearFilters(block, inputs, getFilterableContent);

		window.addEventListener('popstate', () => {
			// Set exisitng values from query string.
			setInputs(block);
			getFilterableContent(contentContainer, getParams(block));
		}, false);
	});
};

document.addEventListener('DOMContentLoaded', initFilterableContent);
